import {
  describeSemanticObservation,
  factorSemantics,
  getLatitudeSpringSeason,
  getLatitudeSpringPosition,
  getLongitudeWindPlace,
  getLongitudeWindPosition,
  getSemanticSelection,
  phenologyStages
} from "../chapters/chapterLabModels";
import "../chapters/chapterLabs.css";
import type { Season } from "../types";
import { useNatureStageState, type NatureStageSnapshot } from "./stageState";

export function getStaticSemanticLabels(snapshot: NatureStageSnapshot): string[] {
  if (snapshot.mode === "phenology") {
    const stage = phenologyStages[Math.round(Math.max(0, Math.min(3, snapshot.stage)))];
    return [
      `桃树：${stage.peach}`,
      `候鸟：${stage.bird}`,
      `昆虫：${stage.insect}`,
      `气象：${stage.temperature}；${stage.humidity}`
    ];
  }
  if (snapshot.mode === "factor") {
    const definition = factorSemantics[snapshot.factorId];
    if (snapshot.factorId === "latitude") {
      const late = getLatitudeSpringSeason(getLatitudeSpringPosition(snapshot.controls)) === "late-spring";
      return [
        late ? "晚春" : "早春",
        describeSemanticObservation(snapshot.factorId, snapshot.controls),
        definition.claim,
        definition.boundary
      ];
    }
    if (snapshot.factorId === "longitude") {
      const coast = getLongitudeWindPlace(getLongitudeWindPosition(snapshot.controls)) === "dalian-coast";
      return [
        coast ? "大连" : "北京",
        describeSemanticObservation(snapshot.factorId, snapshot.controls),
        definition.claim,
        definition.boundary
      ];
    }
    const selected = getSemanticSelection(snapshot.factorId, snapshot.controls);
    return [
      definition.groups[0].options.find((option) => option.value === selected[definition.groups[0].id])?.label ?? definition.groups[0].label,
      definition.groups[1]
        ? definition.groups[1].options.find((option) => option.value === selected[definition.groups[1].id])?.label ?? definition.groups[1].label
        : definition.claim,
      describeSemanticObservation(snapshot.factorId, snapshot.controls),
      definition.boundary
    ];
  }
  return [];
}

export function StaticNatureStage({ season, snapshot: suppliedSnapshot }: { season: Season; snapshot?: NatureStageSnapshot }) {
  const liveSnapshot = useNatureStageState();
  const snapshot = suppliedSnapshot ?? liveSnapshot;
  const labels = getStaticSemanticLabels(snapshot);

  return (
    <div className={`static-stage static-stage--${season}`} data-renderer="2d" data-stage-mode={snapshot.mode}>
      <div className="static-stage__sun" />
      <div className="static-stage__mountain static-stage__mountain--back" />
      <div className="static-stage__mountain static-stage__mountain--front" />
      <div className="static-stage__river" />
      {labels.length > 0 && <div className="static-stage__semantic">
        {labels.map((label, index) => <span className="static-stage__semantic-object" key={`${index}-${label}`}>{label}</span>)}
      </div>}
    </div>
  );
}
